// utils/appSettings.js
// App-wide switches set by admins in AdminDashboard (appConfig/app), read
// through the getAppSettings callable. Off when unreachable.
import { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Same key as AppTutorial.js / App.js — the tutorial version this device last saw.
export const TUTORIAL_SEEN_KEY = 'pandaTutorialSeen_v2';

const DEFAULTS = { tutorialEnabled: false, tutorialVersion: 0 };
let cache = null;

export function fetchAppSettings({ fresh = false } = {}) {
  if (!cache || fresh) {
    cache = httpsCallable(getFunctions(), 'getAppSettings')({})
      .then((r) => ({ ...DEFAULTS, ...(r.data || {}) }))
      .catch(() => { cache = null; return DEFAULTS; });
  }
  return cache;
}

export function setAppSettingsCache(v) {
  cache = Promise.resolve({ ...DEFAULTS, ...v });
}

/** null while loading, then the settings. */
export function useAppSettings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchAppSettings().then((v) => { if (alive) setS(v); });
    return () => { alive = false; };
  }, []);
  return s;
}
